
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TileContainer extends Vue {
  @Prop(Boolean) readonly clickable!: boolean;
}
